module.exports = __webpack_public_path__ + "media/images/design/images/bn_img01-08b7eac8f33dffdb756d66eb570f65ba.jpg";